export default {
  styles: 'Estilos',
  text: {
    title: 'Título',
    subtitle: 'Subtítulo',
    paragraph: 'Texto',
  },
  list: {
    listOrdered: 'Lista numerada',
    bulletList: 'Lista com marcadores',
  },
  typography: {
    bold: 'Negrito',
    italic: 'Itálico',
    underline: 'Sublinhar',
  },
  utils: {
    highlight: 'Cor de destaque',
    link: 'Inserir link',
  },
};
